import React from "react";
import { Link } from "react-router-dom";
import "./services.css";

const ServiceCategories = ({ title, categories = [] }) => {
  return (
    <section className="svc-categories-section">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up" data-aos-duration="800" data-aos-once="true">
          <h2 className="h2-title">{title}</h2>
        </div>

        <div className="row g-4">
          {categories.map((cat, i) => (
            <div
              key={i}
              className="col-lg-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="700"
              data-aos-delay={`${(i % 3) * 100}`}
              data-aos-once="true"
            >
              <div className="svc-cat-card">
                <div className="svc-cat-image">
                  <img src={cat.image} alt={cat.title} loading="lazy" />
                  <div className="svc-cat-overlay" />
                  <div className="svc-cat-icon-badge">
                    <i className={`bi ${cat.icon}`}></i>
                  </div>
                </div>
                <div className="svc-cat-body">
                  <div className="svc-cat-title">{cat.title}</div>
                  <p className="svc-cat-desc">{cat.description}</p>
                  <a
                    href="https://wa.me/971544792905?text=Hi%2C%20I%20need%20refrigerated%20transport%20in%20UAE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="svc-cat-btn"
                  >
                    <i className="bi bi-whatsapp me-2"></i>
                    WhatsApp Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceCategories;
